const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerai(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.1 40.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    width: 134.2,
    height: 40.2,
    rx: 3.7,
    ry: 3.7,
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.2,28.6c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7-2.7,1.2-2.7,2.7,1.2,2.7,2.7,2.7Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,34.8h-4.7l-9.5-24-9.5,24h-4.8l12.2-30.1h4.2l12.1,30.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,4.6h-4.7v30.1h4.7V4.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,4.6h4.7l9.5,24,9.5-24h4.8l-12.2,30.1h-4.2L8.9,4.6Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,8.3v-3.6h-20v30.1h20v-3.6h-15.6v-9.4h11.6v-4h-11.6v-9.4h15.6Z",
    style: {
      fill: "#ffd600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,13.7c0-5-3.9-9.1-8.7-9.1h-13.7v30.2h4.7v-12h6.1l6.5,12h4.8l-7-12.1c4.1-.7,7.2-4.5,7.2-9h0ZM70.3,8.1h7.9c2.9,0,5.3,2.5,5.3,5.5s-2.4,5.5-5.3,5.5h-7.9v-11Z",
    style: {
      fill: "#ffd600"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerai);
export default __webpack_public_path__ + "static/media/verai.01cdeaa94f4480043dc47e837d453170.svg";
export { ForwardRef as ReactComponent };